module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.isShowImageDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.isShowImageDialog = $event
      },
      "closed": _vm.clearImg
    }
  }, [_c('el-carousel', {
    attrs: {
      "indicator-position": "outside",
      "height": "600px"
    }
  }, _vm._l((_vm.imgs), function(src, index) {
    return _c('el-carousel-item', {
      key: index
    }, [_c('img', {
      staticStyle: {
        "max-width": "100%",
        "max-height": "100%",
        "display": "block",
        "margin": "0 auto"
      },
      attrs: {
        "src": src
      }
    })])
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-41e4c871","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/imgPreview/imgPreview.vue
// module id = 1642
// module chunks = 0